import React from 'react';
import { Box, Typography } from '@mui/material';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

export const LANDING_TESTIMONIALS = [
  {
    quote: 'My favorite parts are the help with braking down of tasks into bite size chunks and the personalized prictures.',
  },
  {
    quote: 'I love the AI task Generator. It saves me a lot of time and makes things less overwhelming.  I also enjoy the community/friend asspect that it offers.',
  },
  {
    quote: 'Its a great app, super helpful!',
  },
];

export default function LandingTestimonials() {
  return (
    <Box
      component="section"
      aria-labelledby="landing-testimonials-title"
      sx={{ width: '100%', maxWidth: 1120, mx: 'auto', px: { xs: 1.5, sm: 2 }, pb: 2 }}
    >
      <Box sx={{ textAlign: 'center', mb: { xs: 3, md: 5 } }}>
        <Typography id="landing-testimonials-title" component="h2" variant="h6" sx={{ fontSize: { xs: 16, sm: 20 }, lineHeight: 1.8 }}>
          Testimonials
        </Typography>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(3, minmax(0, 1fr))' }, gap: { xs: 3, md: 3.5 }, alignItems: 'stretch' }}>
        {LANDING_TESTIMONIALS.map((testimonial, index) => (
          <Box component="figure" key={testimonial.quote} sx={{
            position: 'relative', overflow: 'hidden', m: 0, minWidth: 0,
            display: 'flex', flexDirection: 'column', justifyContent: 'center',
            minHeight: { xs: 200, md: 280 }, p: { xs: 2.5, sm: 3 },
            border: '4px solid', borderColor: 'green.main', borderRadius: 8,
            background: (theme) => `linear-gradient(110deg, ${theme.palette.background.paper} 45%, ${theme.palette.green.main}${index === 1 ? '28' : '12'})`,
            boxShadow: (theme) => `0 6px 15px ${theme.palette.secondary.main}, 0 0 28px ${theme.palette.secondary.main}33`,
            transform: { xs: 'none', md: index === 1 ? 'translateY(-10px)' : 'none' },
            transition: 'transform 180ms ease',
            '@media (hover: hover) and (prefers-reduced-motion: no-preference)': {
              '&:hover': { transform: index === 1 ? { xs: 'translateY(-4px)', md: 'translateY(-14px)' } : 'translateY(-4px)' },
            },
            '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
          }}>
            <FormatQuoteIcon aria-hidden="true" sx={{ position: 'absolute', right: 16, top: 12, fontSize: 64, color: 'secondary.main', opacity: 0.16, pointerEvents: 'none' }} />
            <Typography component="blockquote" variant="body2" sx={{
              position: 'relative', m: 0, textAlign: 'left', fontSize: { xs: 12, sm: 13 }, fontStyle: 'italic', lineHeight: 2.2,
            }}>
              “{testimonial.quote}”
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
